import React, { useEffect, useRef, useState } from 'react';

import Dialog from '../../../../common/Dialog';
import { Link } from 'react-router-dom';
import Transition from '../utils/Transition';

function Help() {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const trigger = useRef(null);
  const dropdown = useRef(null);

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  const [modal, setmodal] = useState(false);

  return (
    <div className="relative inline-flex ml-3">
      <button
        title="Disclaimer"
        // ref={trigger}
        className={`w-4 h-4 sm:w-8 sm:h-8 flex items-center justify-center bg-slate-100 hover:bg-slate-200 transition duration-150 rounded-full ${
          dropdownOpen && 'bg-slate-200'
        }`}
        aria-haspopup="true"
        onClick={() => setmodal(true)}
      >
        <span className="sr-only">Need help?</span>
        <svg
          className="w-4 h-4"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="fill-current text-red-500"
            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"
          />
        </svg>
      </button>

      <Dialog
        showDialog={modal}
        positiveButton1={{ text: 'Close', callback: () => setmodal(false) }}
        setShowDialog={setmodal}
        title="Disclaimer"
        body=" Please be aware that this complex social media analysis is conducted using AI and large language models, which may not always be highly accurate. It might contain personal data; therefore, adhere to GDPR policies when using the data. Use your discretion in decision-making."
      />

      {/* <Transition
        className="origin-top-right z-10 absolute top-full right-0 min-w-44 bg-white border border-slate-200 py-1.5 rounded shadow-lg overflow-hidden mt-1"
        show={dropdownOpen}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          ref={dropdown}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setDropdownOpen(false)}
        >
          <div className="text-xs font-semibold text-slate-400 uppercase pt-1.5 pb-2 px-4">
            Need help?
          </div>
          Disclaimer: Please note that this complex social media analysis is
          done using AI and Large Language models, which might not be very
          accurate sometimes. It might have personal data, follow GDPR policies
          for use of the data. Please use your own judgment for your decision
          making.
        </div>
      </Transition> */}
    </div>
  );
}

export default Help;
